
<h2 mat-dialog-title>{{title}}</h2>

<mat-dialog-content>

  <div  *ngIf="isLoading != true">
    
  <div class="details" style="padding-bottom:10px; min-width:500px;"  *ngIf="serviceDetail?.Sections != null" >

      <div class="row">
        <div class="col-sm-4 fieldName">Service Name: </div>
        <div class="col-sm-8">{{serviceName}}</div>
      </div>

      <div class="row">
          <div class="col-sm-4 fieldName">Lectionary Source: </div>
          <div class="col-sm-8">{{service_LectionarySource}}</div>
      </div>
  
      <div class="row">
        <div class="col-sm-4 fieldName">Date: </div>
        <div class="col-sm-8">{{data.date.LongDateStr}}</div>
      </div>

      <div class="row" *ngIf="data.service.Season != null">
          <div class="col-sm-4 fieldName">Season: </div>
          <div class="col-sm-8">{{data.service.Season}}</div>
      </div>

      <div class="row">
        <div class="col-sm-4 fieldName">Lectionary Year: </div>
        <div class="col-sm-8">{{serviceDetail.LectionaryYearStr}}</div>
      </div>

      <div class="row">
        <div class="col-sm-4 fieldName">Feast Type: </div>
        <div class="col-sm-8">{{data.service.FeastType}}</div>
    </div>


        <div class="row" *ngIf="data.service.VestmentColors != null">
          <div class="col-sm-4 fieldName"> Vestment Colors: </div>
          <div class="col-sm-8">

            <app-vestment-color-display [colors]="data.service.VestmentColors"></app-vestment-color-display>

          </div>
      </div>

      <div class="row" *ngIf="data.service.Proper != null">
          <div class="col-sm-4 fieldName">Proper</div>
          <div class="col-sm-8">{{data.service.Proper}}</div>
      </div>

      <div style="margin-top:10px;">
        <div class="row">
            <div class="col-sm-4 fieldName"><a [href]="urlToHtmlPreview" target="propers">Propers:</a> </div> 
        </div>

        <div *ngIf="serviceDetail.Sections.length > 0" class="propersIndex">

          <section *ngFor="let section of serviceDetail.Sections" > 
  
            <div class="sectionPart" *ngIf="section.SectionName != null">
                <div class="name">{{section.SectionName}}</div>
            </div>

            
            <div *ngFor="let content of section.Content" class="sectionPart">  
 
                  <span *ngIf="content.Name != null" class="name">{{content.Name}}: </span> 
                  <span>{{joinArray(content.ItemGroups)}}</span>   
 
                 
            </div> 

          </section>
 
  
    </div>

        <div *ngIf="serviceDetail.Sections.length == 0"> 
            <div class="row">
              <div class="col-sm-12" style="text-align: center; font-style:italic">There are no readings</div> 
            </div>
          </div>
          
    </div>

 
    <div class="text-right" style="margin-bottom:20px;">
      <button mat-button [mat-dialog-close]="true" class="btn">Close</button>
    </div>


  </div>

</div>


  <div *ngIf="isLoading==true">
    <div style="padding:10%;">
      <div></div>
      <div style="text-align: center; margin:auto">
  
        <h3>One moment please...</h3>
  
        <img src="/assets/img/spinner.gif">
  
      </div>
   </div>
  
  </div>

</mat-dialog-content>

